/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: any; output: any; }
};

export type Mutation = {
  __typename?: 'Mutation';
  publishScheduleData: MutationResponse;
};


export type MutationPublishScheduleDataArgs = {
  input: PublishScheduleDataInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type PublishScheduleDataInput = {
  scheduleDataId: Scalars['String']['input'];
  scheduleEntries: Array<InputMaybe<PublishScheduleDataScheduleEntriesInput>>;
  sourceDocumentName: Scalars['String']['input'];
  supportedRoutes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PublishScheduleDataScheduleEntriesInput = {
  destinationLabel: Scalars['String']['input'];
  direction: Scalars['String']['input'];
  route: Scalars['String']['input'];
  scheduledArrival: Scalars['String']['input'];
  serviceDay: Scalars['String']['input'];
  stopId: Scalars['String']['input'];
  stopName: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  refreshScheduledBuses: ScheduledBusResults;
  viewScheduledBuses: ScheduledBusResults;
};

export type ScheduledBusResults = {
  __typename?: 'ScheduledBusResults';
  lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  scheduleEntries?: Maybe<Array<Maybe<ScheduledBusResultsScheduleEntries>>>;
};

export type ScheduledBusResultsScheduleEntries = {
  __typename?: 'ScheduledBusResultsScheduleEntries';
  destinationLabel?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  scheduledArrival?: Maybe<Scalars['String']['output']>;
  serviceDay?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['String']['output']>;
  stopName?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
};

export type ViewScheduledBusesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewScheduledBusesQueryQuery = { __typename?: 'Query', viewScheduledBuses: { __typename: 'ScheduledBusResults', lastUpdatedAt?: any | null, scheduleEntries?: Array<{ __typename: 'ScheduledBusResultsScheduleEntries', route?: string | null, direction?: string | null, stopId?: string | null, stopName?: string | null, serviceDay?: string | null, tripId?: string | null, scheduledArrival?: string | null, destinationLabel?: string | null } | null> | null } };

export type RefreshScheduledBusesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RefreshScheduledBusesQueryQuery = { __typename?: 'Query', refreshScheduledBuses: { __typename: 'ScheduledBusResults', lastUpdatedAt?: any | null, scheduleEntries?: Array<{ __typename: 'ScheduledBusResultsScheduleEntries', route?: string | null, direction?: string | null, stopId?: string | null, stopName?: string | null, serviceDay?: string | null, tripId?: string | null, scheduledArrival?: string | null, destinationLabel?: string | null } | null> | null } };

export type PublishScheduleDataMutationMutationVariables = Exact<{
  input: PublishScheduleDataInput;
}>;


export type PublishScheduleDataMutationMutation = { __typename?: 'Mutation', publishScheduleData: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };


export const ViewScheduledBusesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewScheduledBusesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewScheduledBuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"stopId"}},{"kind":"Field","name":{"kind":"Name","value":"stopName"}},{"kind":"Field","name":{"kind":"Name","value":"serviceDay"}},{"kind":"Field","name":{"kind":"Name","value":"tripId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrival"}},{"kind":"Field","name":{"kind":"Name","value":"destinationLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}}]}}]} as unknown as DocumentNode<ViewScheduledBusesQueryQuery, ViewScheduledBusesQueryQueryVariables>;
export const RefreshScheduledBusesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefreshScheduledBusesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshScheduledBuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"stopId"}},{"kind":"Field","name":{"kind":"Name","value":"stopName"}},{"kind":"Field","name":{"kind":"Name","value":"serviceDay"}},{"kind":"Field","name":{"kind":"Name","value":"tripId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrival"}},{"kind":"Field","name":{"kind":"Name","value":"destinationLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}}]}}]} as unknown as DocumentNode<RefreshScheduledBusesQueryQuery, RefreshScheduledBusesQueryQueryVariables>;
export const PublishScheduleDataMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishScheduleDataMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishScheduleDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishScheduleData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PublishScheduleDataMutationMutation, PublishScheduleDataMutationMutationVariables>;